var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card-horizontal position-relative"
  }, [_c('div', {
    staticClass: "row no-gutters justify-content-start align-items-center outline"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('MainImage', {
    attrs: {
      "src": _vm.src,
      "srcset": _vm.srcset,
      "alt": _vm.alt,
      "ratio": _vm.ratio
    }
  })], 1), _vm._v(" "), _c('MdmLink', {
    staticClass: "col-8 expand-link",
    attrs: {
      "url": _vm.url,
      "is-scramble-link": _vm.isScrambleLink
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.$root.$emit('generic-tracking', $event, {
          data: _vm.tracking
        });
      }
    }
  }, [_c('p', {
    staticClass: "label px-3 mb-0 font-weight-bold",
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _vm.description ? _c('p', {
    staticClass: "description px-3 mb-0 d-none d-md-block",
    domProps: {
      "textContent": _vm._s(_vm.description)
    }
  }) : _vm._e()])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };